var map = {
	"./Amount.vue": "0d4d",
	"./AssetIcon.vue": "4e57",
	"./Avatar.vue": "df3a",
	"./Box.vue": "f8e4",
	"./BoxSelectLeverage.vue": "cc2f",
	"./BoxSelectLeverageType.vue": "50b2",
	"./BoxSelectLeveragedPosition.vue": "753c",
	"./BoxSelectPool.vue": "3227",
	"./BoxSelectThreshold.vue": "378e",
	"./ButtonSelectLeverage.vue": "7924",
	"./ButtonSelectLeverageType.vue": "71fc",
	"./ButtonSelectLeveragedToken.vue": "c019",
	"./ButtonSelectPool.vue": "2ff1",
	"./ButtonSelectToken.vue": "c405",
	"./Icon.vue": "cdae",
	"./InputAmount.vue": "365d",
	"./LabelBalance.vue": "2d63",
	"./LeverageNav.vue": "e3ab",
	"./Modal.vue": "714b",
	"./Modal/About.vue": "8188",
	"./Modal/Account.vue": "34ec",
	"./Modal/SelectLeverage.vue": "9d2e",
	"./Modal/SelectLeverageType.vue": "0e43",
	"./Modal/SelectLeveragedPosition.vue": "cd95",
	"./Modal/SelectLeveragedToken.vue": "f780",
	"./Modal/SelectPool.vue": "bd33",
	"./Modal/SelectToken.vue": "c8e2",
	"./Modal/SelectUnit.vue": "ad54",
	"./Nav.vue": "216c",
	"./Pie.vue": "4336",
	"./PoolInfo.vue": "82b7",
	"./PoolNav.vue": "8280",
	"./Ticker.vue": "1a12",
	"./TooltipIcon.vue": "50ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4daf";